import { render } from "./GameForm.vue?vue&type=template&id=08036313"
import script from "./GameForm.vue?vue&type=script&lang=js"
export * from "./GameForm.vue?vue&type=script&lang=js"
script.render = render

export default script